import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
//import VueGtm from "vue-gtm";
import { createGtm } from "@gtm-support/vue-gtm";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { createI18n } from "vue-i18n";
import frFR from "./locales/fr.json";
import { loadFonts } from "./plugins/webfontloader";
//import VueExcelEditor from "vue3-excel-editor"; probleme avec version 3.4.6 de vuetify
import { Icon } from "leaflet";
import { createHead } from "@vueuse/head";
import "@mdi/font/css/materialdesignicons.css";
const head = createHead();

// delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

loadFonts();

type MessageSchema = typeof frFR;

const i18n = createI18n<[MessageSchema], "fr-FR">({
  locale: "fr-FR",
  legacy: false,
  messages: {
    "fr-FR": frFR,
  },
});
const pinia = createPinia();

createApp(App)
  .use(head)
  .use(router)
  .use(i18n)
  .use(vuetify)
  .use(pinia)
  .use(
    createGtm({
      id: process.env.VUE_APP_GTM_ID,
      vueRouter: router,
    }),
  )
  //.use(VueGtm, {
  //  id: process.env.VUE_APP_GTM_ID, // Votre ID Google Tag Manager
  //})
  .mount("#app");
